require('./').polyfill()



// WEBPACK FOOTER //
// ./~/raf/polyfill.js